import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { createRpiDrawerView } from "../../../rpi-core/drawer/RpiDrawer";
import { RpaDrawer, RpaDrawerProps } from "../../../rpi-core/drawer/RpaDrawer";
import { CreatePaymentMethod } from "../../admin/billing/PaymentMethodCreateViewV2";

const useStyles = createStyles({
  body: {
    padding: `0 ${tokens.spacing[6]}`,
  },
});

export const SettingsAddPaymentMethodView = createRpiDrawerView<Pick<RpaDrawerProps, "opened" | "onClose">>(
  ({ opened, onClose }) => {
    const { classes } = useStyles();

    return (
      <RpaDrawer title="Add Payment Method" opened={opened} onClose={onClose}>
        <div className={classes.body}>
          <CreatePaymentMethod onComplete={onClose} onCancel={onClose} />
        </div>
      </RpaDrawer>
    );
  }
);
